export default "__VITE_ASSET__BMRYWdN0__"